import fetchAPI from '../../../../lib/utils/fetch-api'

export default async function accountingAPI(path: string, options?: Record<string, unknown>) {
  let result
  try {
    result = await fetchAPI(path, options)
  } catch (error: any) {
    if (error?.name === 'AbortError')
      throw new Error('Сервер ERP не ответил вовремя. Повторите попытку.')
    throw error
  }
  const errors = result?.errors || result?.error
  if (errors) {
    const parts = Array.isArray(errors) ? errors : [errors]
    throw new Error(
      parts
        .map(part =>
          typeof part === 'string'
            ? part
            : part?.message || part?.detail || part?.msg || 'Не удалось выполнить действие',
        )
        .join(', '),
    )
  }
  return result
}
